import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

const service = axios.create({
    baseURL: 'https://winter-cargateapi.moewaikyaw.com/',
    timeout: 15000
})

// ✅ Request interceptor
service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            config.headers['Authorization'] = getToken()
        }
        return config
    },
    error => Promise.reject(error)
)

// ✅ Response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data

        if (res.success === false) {
            Message({
                message: res.errorMsg || 'Error occurred',
                type: 'error',
                duration: 3000
            })

            if (res.code === 401) {
                MessageBox.confirm(
                    'You are logged out. Login again?',
                    'Session Expired',
                    {
                        confirmButtonText: 'Login Again',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }
                ).then(() => {
                    store.dispatch('FedLogOut').then(() => {
                        location.reload()
                    })
                })
            }

            return Promise.reject(new Error(res.errorMsg))
        }

        return res
    },
    error => {
        console.error('Axios Error:', error)

        let message = error.response?.data?.errorMsg || error.message

        if (error.code === 'ECONNABORTED' || message.includes('timeout')) {
            message = 'Request timed out. Please try again.'
        }

        Message({
            message,
            type: 'error',
            duration: 3000
        })

        return Promise.reject(error)
    }
)

export default service
